// extracted by mini-css-extract-plugin
export var container = "_sz-0";
export var table = "_sz-2";
export var tableWrapper = "_sz-1";